import { cloneElement, Fragment } from 'react';
import { IntlProvider, intlShape } from 'react-intl';

import { shallow, mount } from 'enzyme';

import { defaultTheme } from '@/themes';

const intlProvider = new IntlProvider({
  locale: 'en',
  messages: {},
  textComponent: Fragment,
});
const { intl } = intlProvider.getChildContext();

const theme = defaultTheme;

const nodeWithIntlThemeProps = node => cloneElement(node, { intl, theme });

export const shallowTest = (node, { context, ...options } = {}) =>
  shallow(nodeWithIntlThemeProps(node), {
    context: {
      ...context,
      intl,
      theme,
    },
    ...options,
  });

export const mountTest = (
  node,
  { context, childContextTypes, ...options } = {},
) =>
  mount(nodeWithIntlThemeProps(node), {
    context: {
      ...context,
      intl,
      theme,
    },
    childContextTypes: {
      intl: intlShape,
      ...childContextTypes,
    },
    ...options,
  });
